import React from 'react';
import MediaManager from '../MediaManager/MediaManager';

function MediaManagerSection({
  handleAddToAdHocPlaylist,
  handleLoadToUpNext,
  adHocPlaylist,
  deviceType,
  onSavePlaylist,
  onDeletePlaylist,
  onLoadSavedPlaylist,
  savedPlaylists,
  existingPlaylist,
  playlistName,
  showLoadToUpNextButton,
  showPlaylist = true,
  siteId = null,
  site = null,
  selectedDevice = null,
  showOverlayAdsTab = false,
  overlayPlaybackMode = 'auto',
  onPlayInSuitestream = null
}) {
  return (
    <div className="media-manager-section">
      <MediaManager
        playlistName={playlistName}
        adHocMode={true}
        existingPlaylist={adHocPlaylist}
        onUpdatePlaylist={handleAddToAdHocPlaylist}
        onLoadToUpNext={handleLoadToUpNext}
        deviceType={deviceType}
        categoryFixed={false}
        onSavePlaylist={onSavePlaylist}
        onDeletePlaylist={onDeletePlaylist}
        onLoadSavedPlaylist={onLoadSavedPlaylist}
        savedPlaylists={savedPlaylists}
        showLoadToUpNextButton={showLoadToUpNextButton}
        showPlaylist={showPlaylist}
        siteId={siteId}
        site={site}
        selectedDevice={selectedDevice}
        showOverlayAdsTab={showOverlayAdsTab}
        overlayPlaybackMode={overlayPlaybackMode}
        onPlayInSuitestream={onPlayInSuitestream}
      />
    </div>
  );
}

export default MediaManagerSection;
